import { EAuthenticateStatus, ECheckEmailStatus } from '../../../../types/authentication';
import { EActiveFlow } from '../../../../types/flow';
import { ERegisterErrorType, ERegisterStatus } from '../../../../types/registration';
import { isEmail } from '../../../../utils/validation';
export function viewStateEmailSelector(state) {
  var viewData = state.view.data;
  if (viewData && viewData.email) {
    return viewData.email;
  } else if (state.login && isEmail(state.login)) {
    return state.login;
  }
  return '';
}
export function isFormSubmitting(state) {
  var activeFlow = state.activeFlow,
    authentication = state.authentication,
    registration = state.registration;
  if (activeFlow === EActiveFlow.Registration) {
    return registration.register.status === ERegisterStatus.Loading || registration.register.status === ERegisterStatus.Succeed;
  } else if (activeFlow === EActiveFlow.Authentication) {
    return authentication.authenticate.status === EAuthenticateStatus.Loading || authentication.authenticate.status === EAuthenticateStatus.Succeed;
  } else {
    return authentication.checkEmail.status === ECheckEmailStatus.Loading;
  }
}
export function hasPhoneErrorSelector(state) {
  return state.registration.register.error !== undefined && state.registration.register.errorType === ERegisterErrorType.Phone;
}
export function phoneErrorSelector(state) {
  return hasPhoneErrorSelector(state) ? state.registration.register.error : undefined;
}